module.exports = __webpack_public_path__ + "img/amatriciana.73be0509.jpg";